const CSP = [
	'Aucune',
	'Agriculteurs exploitants',
	'Artisans, commerçants et chefs d\'entreprise',
	'Cadres et professions intellectuelles supérieures',
	'Professions Intermédiaires',
	'Employés',
	'Ouvriers',
	'Retraités',
	'Autres personnes sans activité professionnelle'
]

export default CSP



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/CSP.js